import { GetStartedQuestionnaireForm } from '../../GetStarted/schemas';
import { POTSCustomerLineForm } from './schemas';
import { ReviewTicketForm } from '../../Review/schemas';
import { questionnaireFormToReviewTicketDefaultValues } from '../../BaseComponents/questionnaireFormToReviewTicketDefaultValues';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';
import {
  NON_STANDARD_TOOLS_REQUESTED_LABEL_PREFIX,
  NON_STANDARD_TOOLS_REQUESTED_LABEL_SUFFIX,
} from '../../utils/nonStandardToolsSOWUtils';
import { formatContactTesting } from 'shared/util/util';

export const POTSCustomerLineFormToReview = (
  questionnaire: GetStartedQuestionnaireForm,
  form: POTSCustomerLineForm,
): Partial<ReviewTicketForm> => {
  return {
    ...questionnaireFormToReviewTicketDefaultValues(questionnaire),
    scopeOfWork: formToSOW(form),
    nonStandardTools: form.nonStandardTools,
  };
};

const formToSOW = (form: POTSCustomerLineForm) => {
  return [
    form.nonStandardTools.isNeeded
      ? `${NON_STANDARD_TOOLS_REQUESTED_LABEL_PREFIX} ${form.nonStandardTools.nonStandardTools} ${NON_STANDARD_TOOLS_REQUESTED_LABEL_SUFFIX}\n`
      : '',
    `Service technician needed on site to repair an existing POTS line.`,
    form.POTSTelephoneNumber
      ? `\nThe telephone number associated with this line is ${formatPhoneNumber(
          form.POTSTelephoneNumber,
        )}.`
      : '',
    form.mpoe
      ? `\nThe MPOE (Minimum Point of Entry) for this line is ${form.mpoe}.`
      : '',
    form.whatIsUsedFor
      ? `\nThe POTS line is currently being used for ${form.whatIsUsedFor}.`
      : '',
    form.techToTestWith.techToTestWith !== 'No'
      ? `\n${
          form.itTestingContacts.length > 1
            ? 'The technician should test with the following technical contacts'
            : 'The technician will need to test with'
        }: ${formatContactTesting(form.itTestingContacts)}`
      : '',
  ]
    .filter((l) => l)
    .join('\n');
};
